export class SupplierContactType {
    id: number;
    name: string;
    enabled: boolean;
    type: string;
    isCritical: boolean;
}

export class Country {
    countryID: number;
    name: string;
    abbreviation: string;
    enabled: boolean;
    defaultCurrencyID: number;
    regionID: number;
}

export class Role {
    id: string;
    description: string;
    enabled: boolean;
    isSystemRole: boolean;
    isCritical: boolean;
}

export class SupplierPart {
    partID: number;
    partNumber: string;
    description: string;
}

export class AddressType {
    id: number;
    name: string;
    enabled: boolean;
}
